/**
 * Sprint V41 · Share-URL-Aufraeumen (Mo 15.09.2026, CoS-Quick-Win)
 *
 * Zweck: Empfaengt geteilte Referral-Links im sauberen Pfad-Format
 * `/via/:code`, schreibt den Referral-Code in localStorage (30-Tage-TTL)
 * und redirected sofort auf die Landing Page.
 *
 * Vorteil: Der geteilte Link enthaelt keine Query-Parameter mehr →
 * sieht in WhatsApp/E-Mail wie eine normale Seiten-URL aus, nicht wie
 * eine Datenkrake.
 *
 * Backward-Compat: Der alte Reader in App.js (`?ref=CODE`) bleibt
 * bestehen — bereits geteilte Links funktionieren weiter.
 */
import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";

import { API } from "@/lib/api";

const CODE_REGEX = /^[A-Z0-9]{4,24}$/;

export default function ViaRedirect() {
  const { code } = useParams();
  const normalized = (code || "").trim().toUpperCase();
  const valid = CODE_REGEX.test(normalized);

  useEffect(() => {
    if (!valid) return;
    try {
      const now = Date.now();
      const payload = { code: normalized, ts: now, ttl: 30 * 24 * 60 * 60 * 1000 };
      localStorage.setItem("f4s_ref_code", JSON.stringify(payload));
    } catch { /* localStorage disabled */ }

    // Server-side Click-Attribution — fire-and-forget, blockt Redirect nicht.
    try {
      fetch(`${API}/share/via-hit`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: normalized }),
        keepalive: true,
      }).catch(() => { /* silent */ });
    } catch { /* silent */ }
  }, [normalized, valid]);

  // Redirect zur Landing Page. `replace` sorgt dafuer, dass der User beim
  // Zurueck-Button nicht in einer Redirect-Schleife landet.
  return <Navigate to="/" replace />;
}
